import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomeIndex from "../pages/HomeIndex";
import HomePage from "../pages/Home";
 
const RouterComponent: React.FC = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<HomeIndex />}>
                    <Route index element={<HomePage />} />
 
                </Route>
            </Routes>
        </Router>
    );
};

export default RouterComponent;
